export const IOTA_DECIMALS: number = 6;
export const APEIN_DECIMALS: number = 18;
export const MAGICSEA_LP_DECIMALS: number = 18;
export const APEDAO_SAFE_WALLET_ADDRESS = '0x3041E3Aa2d7bbf5443946d56436470c3832FB8aD';
